import { render, staticRenderFns } from "./TheadReportByAgeAndWeek.vue?vue&type=template&id=4a5a17e3"
import script from "./TheadReportByAgeAndWeek.vue?vue&type=script&lang=js"
export * from "./TheadReportByAgeAndWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports